import { Divider } from '@vk-cloud-solutions/marketing-ui';
import { useRouter } from 'next/navigation';

import { ArticleCard } from '~components/ArticleCard/ArticleCard';
import { ArticleCardProps } from '~components/ArticleCard/ArticleCard.types';
import { SectionMods } from '~components/Section/Section.types';
import { SectionEvent } from '~components/SectionEvent/SectionEvent';
import { useCategory } from '~hooks/useCategory';
import { ArticleCardImagePosition } from '~types/Article.types';

import styles from './CategoryPageContent.module.scss';
import { CategoryPageContentProps } from './CategoryPageContent.types';

export const CategoryPageContent = ({
  articles,
  sectionEvent,
  category,
}: CategoryPageContentProps) => {
  const router = useRouter();
  const { setCategory } = useCategory();
  const cardsInSectionCount = Math.ceil(articles.length / 2);

  const handleArticleClick = (article: ArticleCardProps) => {
    setCategory(category);
    router.push(article.href);
  };

  return (
    <div className={styles.catalog}>
      {articles
        ?.slice(0, cardsInSectionCount)
        .map((card, index) => (
          <ArticleCard
            key={card.id}
            {...card}
            imagePosition={
              index % 3 === 1
                ? ArticleCardImagePosition.Bottom
                : ArticleCardImagePosition.Top
            }
            categories={[category]}
            onClick={() => handleArticleClick(card)}
          />
        ))}

      {sectionEvent && (
        <SectionEvent
          {...sectionEvent}
          mods={[SectionMods.SeparatorL]}
          className={styles.event}
        />
      )}

      {!sectionEvent && <Divider className={styles.divider} />}

      {articles
        ?.slice(cardsInSectionCount, articles.length)
        .map((card, index) => (
          <ArticleCard
            key={card.id}
            {...card}
            imagePosition={
              index % 3 === 1
                ? ArticleCardImagePosition.Bottom
                : ArticleCardImagePosition.Top
            }
            categories={[category]}
          />
        ))}
    </div>
  );
};
